import React from 'react'
import PropTypes from 'prop-types'

const TabButtonOutlined = ({ label, onClick, onKeyPress }) => {
  return (
    <svg
      fill="none"
      height="37"
      onClick={onClick}
      onKeyPress={onKeyPress}
      role="button"
      style={{ cursor: 'pointer', overflow: 'visible' }}
      tabIndex={0}
      viewBox="0 0 200 37"
      width="200"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M132 0C132 0 132.164 0.00355691 132.464 0.0205078C132.513 0.0227723 132.563 0.0263125 132.612 0.0292969C135.955 0.244611 151.98 2.1318 155.521 18.5947C159.481 37.0001 183.27 37 183.27 37H142V37.0098H42V37H0C0 37 23.7874 37 27.7471 18.5947C31.696 0.238765 51.1639 0.00114396 51.2686 0V0.0390625C51.5102 0.0215915 51.7539 0.00976563 52 0.00976562H132V0Z"
        fill="none"
        stroke="#EEF0F2"
        strokeWidth="1.5"
      />
      <text
        dominantBaseline="middle"
        fill="inherit"
        fontFamily="inherit"
        fontSize="16"
        fontWeight="400"
        textAnchor="middle"
        x="92"
        y="19"
      >
        {label}
      </text>
    </svg>
  )
}

TabButtonOutlined.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
}

export default TabButtonOutlined
